import { render, staticRenderFns } from "./btndefault.vue?vue&type=template&id=afbc8472&scoped=true&"
import script from "./btndefault.vue?vue&type=script&lang=js&"
export * from "./btndefault.vue?vue&type=script&lang=js&"
import style0 from "./btndefault.vue?vue&type=style&index=0&id=afbc8472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbc8472",
  null
  
)

export default component.exports